import { Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TablePagination, TableRow, } from "@mui/material";
import React, { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import Home from "../../home/Home";
import { getDate } from "../../Utils/Common";
import { useEffect } from "react";
import DSR_Services from "../../../Services/Reports/DSR_Services"
import Snackbar from '../../Snacbar'
import HashLoader from "react-spinners/HashLoader";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: 'rgb(61, 195, 177)',
    color: 'black',
    textAlign: "center",
    fontFamily: 'Times New Roman',
    fontWeight: 'bold',
  },
  [`&.${tableCellClasses.body}`]: {
    textAlign: "center",
    fontSize: 14,
    fontFamily: 'Times New Roman',
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));
const ItemPap = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  border: " 1px solid black",
  // backgroundColor: "#C8EDE7",
  height: "100%",
}));
const ItemPap1 = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  border: " 1px solid black",
  backgroundColor: "white",
}));

function DSR3() {
  const mystyle = {
    border: " 1px solid black",
    width: "9rem",fontFamily: 'Times New Roman',
  };
  const mystyle1 = {
    fontWeight: "bolder",
    color: "#0b64c5",fontFamily: 'Times New Roman',
  };

  ///
  const [message, setMessage] = useState('');
  const [open, setOpen] = useState(false);
  const [severit, setseverit] = useState('');
  const [showProcs, setshowProcs] = useState(false)
  const [reportProcs, setreportProcs] = useState(false)
  const [clearProcs, setclearProcs] = useState(false)
  const [details1, setdetails1] = useState([]);
  const [details2, setdetails2] = useState([]);
  const [details3, setdetails3] = useState([]);
  const [FilteredDetails, setFilteredDetails] = useState([]);
  const [loading, setloading] = useState(false)

  const [dsr3Values, setdsr3Values] = useState({
    from: getDate(),
    to: getDate(),
    branch: '-1',
    customer: '-1',
    operation: '-1',
  });
  const fromhandlechange = (e) => {
    setdsr3Values({ ...dsr3Values, from: e.target.value })
  };
  const tohandlechange = (e) => {
    setdsr3Values({ ...dsr3Values, to: e.target.value })
  };
  const branchhandlechange = (e) => {
    setdsr3Values({ ...dsr3Values, branch: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };
  const customerhandlechange = (e) => {
    setdsr3Values({ ...dsr3Values, customer: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };
  const operationhandlechange = (e) => {
    setdsr3Values({ ...dsr3Values, operation: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };
  //error message
  const handleClose = () => {
    setOpen(false)
  }
  ///getfunctions
  const getfunctions = () => {
    DSR_Services.selectBranchDetails().then(res => {
      setdetails1(res.data);
    })
    DSR_Services.getCustomerBasedCustomerType('Importer').then(res => {
      setdetails2(res.data);
    })
  }
  // btnOperations===>
  const showBtnClick = () => {
    setshowProcs(true)
    setloading(true)
    setPage(0)
    var importer_iec_no, regionalId, operationType = '';
    if (dsr3Values.customer === 'ALL') {
      importer_iec_no = '-1'
    } else {
      importer_iec_no = dsr3Values.customer
    }
    if (dsr3Values.branch === 'ALL') {
      regionalId = -1
    } else {
      regionalId = dsr3Values.branch
    }
    if (dsr3Values.operation === 'ALL') {
      operationType = '-1'
    } else {
      operationType = dsr3Values.operation
    }
    let details = {
      fromDate: dsr3Values.from, toDate: dsr3Values.to, importer_iec_no: importer_iec_no, regionalId: regionalId, operationType: operationType,
      transitTypeId: '-1', customId: -1, clearanceStatus: '-1', employeeId: -1
    }
    DSR_Services.getDSR_Report3(details).then(res => {
      const data = res.data;
      const details = data.map((item) => item);
      if (details[0] === [] || !details[0]) {
        setMessage('No Record Found');
        setseverit('warning')
        setOpen(true)
        setshowProcs(false)
        setloading(false)
      } else {
        setdetails3(res.data);
        setFilteredDetails(res.data);
        setshowProcs(false)
        setloading(false)
      }
    })
  }
  const reportBtnClick = () => {
    setreportProcs(true)
    if (!details3[0]) {
      setMessage('No Record Found')
      setseverit('warning')
      setOpen(true)
      setreportProcs(false)
    } else {
      var tableContent, contenall = '';
      for (let i = 0; i < details3.length; i++) {
        if (details3[i].regionalName !== '') {
          tableContent = details3[i].regionalName + "!"
        } else {
          tableContent += '   !'
        }
        if (details3[i].operationType !== '') {
          tableContent += details3[i].operationType + "!"
        }
        else {
          tableContent += '  !';
        }
        if (details3[i].consignmentNumber !== '') {
          tableContent += details3[i].consignmentNumber + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].transitDate !== '') {
          tableContent += details3[i].transitDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].licenceNo !== '') {
          tableContent += details3[i].licenceNo + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].importer_iec_no !== '') {
          tableContent += details3[i].importer_iec_no + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].branchSlNo !== '') {
          tableContent += details3[i].branchSlNo + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].importer_name !== '') {
          tableContent += details3[i].importer_name + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].importerAddress !== '') {
          tableContent += details3[i].importerAddress + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].importerAddress2 !== '') {
          tableContent += details3[i].importerAddress2 + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].importerCity !== '') {
          tableContent += details3[i].importerCity + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].importerState !== '') {
          tableContent += details3[i].importerState + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].importerPincode !== '') {
          tableContent += details3[i].importerPincode + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].cusHouseCode !== '') {
          tableContent += details3[i].cusHouseCode + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].countryOfOrigin !== '') {
          tableContent += details3[i].countryOfOrigin + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].origin_portName !== '') {
          tableContent += details3[i].origin_portName + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].countryOfCmName !== '') {
          tableContent += details3[i].countryOfCmName + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].certificateTypeDesc !== '') {
          tableContent += details3[i].certificateTypeDesc + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].certificateType !== '') {
          tableContent += details3[i].certificateType + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].certificateNo !== '') {
          tableContent += details3[i].certificateNo + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].totFrtRt !== '') {
          tableContent += details3[i].totFrtRt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].totInsRt !== '') {
          tableContent += details3[i].totInsRt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].totMiscRt !== '') {
          tableContent += details3[i].totMiscRt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].totAssesableVal !== '') {
          tableContent += details3[i].totAssesableVal + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].totDuty !== '') {
          tableContent += details3[i].totDuty + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].grossWt !== '') {
          tableContent += details3[i].grossWt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].totIns !== '') {
          tableContent += details3[i].totIns + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].transitTypeCode !== '') {
          tableContent += details3[i].transitTypeCode + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].igmSrNo !== '') {
          tableContent += details3[i].igmSrNo + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].rotNo !== '') {
          tableContent += details3[i].rotNo + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].rotDate !== '') {
          tableContent += details3[i].rotDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].mawbNo !== '') {
          tableContent += details3[i].mawbNo + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].mawb_date !== '') {
          tableContent += details3[i].mawb_date + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].hawb_no !== '') {
          tableContent += details3[i].hawb_no + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].hawbDate !== '') {
          tableContent += details3[i].hawbDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].inwardDate !== '') {
          tableContent += details3[i].inwardDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].noPkg !== '') {
          tableContent += details3[i].noPkg + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].grossWt !== '') {
          tableContent += details3[i].grossWt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].unit !== '') {
          tableContent += details3[i].unit + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].gateWay_igmNo !== '') {
          tableContent += details3[i].gateWay_igmNo + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].gateWay_igmDate !== '') {
          tableContent += details3[i].gateWay_igmDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].gateWay_port_code !== '') {
          tableContent += details3[i].gateWay_port_code + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].totDuty1 !== '') {
          tableContent += details3[i].totDuty1 + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].invoiceSrNo !== '') {
          tableContent += details3[i].invoiceSrNo + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].invoiceNumber !== '') {
          tableContent += details3[i].invoiceNumber + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].invoiceDate !== '') {
          tableContent += details3[i].invoiceDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].invoiceVal !== '') {
          tableContent += details3[i].invoiceVal + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].invoiceCur !== '') {
          tableContent += details3[i].invoiceCur + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].exRate !== '') {
          tableContent += details3[i].exRate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].terms_code !== '') {
          tableContent += details3[i].terms_code + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].nattransaction !== '') {
          tableContent += details3[i].nattransaction + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].payTerms !== '') {
          tableContent += details3[i].payTerms + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].supName !== '') {
          tableContent += details3[i].supName + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].supplierAddress !== '') {
          tableContent += details3[i].supplierAddress + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].supAddress2 !== '') {
          tableContent += details3[i].supAddress2 + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].supAddress3 !== '') {
          tableContent += details3[i].supAddress3 + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].supCountry !== '') {
          tableContent += details3[i].supCountry + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].frtVal !== '') {
          tableContent += details3[i].frtVal + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].frtCur !== '') {
          tableContent += details3[i].frtCur + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].frtRt !== '') {
          tableContent += details3[i].frtRt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].insVal !== '') {
          tableContent += details3[i].insVal + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].insCur1 !== '') {
          tableContent += details3[i].insCur1 + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].insRt !== '') {
          tableContent += details3[i].insRt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].totIns1 !== '') {
          tableContent += details3[i].totIns1 + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].loadCur !== '') {
          tableContent += details3[i].loadCur + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].loadRt !== '') {
          tableContent += details3[i].loadRt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].miscVal !== '') {
          tableContent += details3[i].miscVal + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].miscCur !== '') {
          tableContent += details3[i].miscCur + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].miscRt !== '') {
          tableContent += details3[i].miscRt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].hssLoadAmt !== '') {
          tableContent += details3[i].hssLoadAmt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].hssLoadRt !== '') {
          tableContent += details3[i].hssLoadRt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].discRate !== '') {
          tableContent += details3[i].discRate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].disAmt !== '') {
          tableContent += details3[i].disAmt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].svbLoad !== '') {
          tableContent += details3[i].svbLoad + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].sellName !== '') {
          tableContent += details3[i].sellName + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].sellAddress1 !== '') {
          tableContent += details3[i].sellAddress1 + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].sellAddress2 !== '') {
          tableContent += details3[i].sellAddress2 + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].sellAddress3 !== '') {
          tableContent += details3[i].sellAddress3 + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].sellCountry !== '') {
          tableContent += details3[i].sellCountry + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].sellPincode !== '') {
          tableContent += details3[i].sellPincode + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].disrt1 !== '') {
          tableContent += details3[i].disrt1 + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].disAmt1 !== '') {
          tableContent += details3[i].disAmt1 + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].svbLoad1 !== '') {
          tableContent += details3[i].svbLoad1 + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].itemSrNo !== '') {
          tableContent += details3[i].itemSrNo + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].item_description !== '') {
          tableContent += details3[i].item_description + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].itemDesc !== '') {
          tableContent += details3[i].itemDesc + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].unitQty !== '') {
          tableContent += details3[i].unitQty + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].unitCode !== '') {
          tableContent += details3[i].unitCode + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].unitPri !== '') {
          tableContent += details3[i].unitPri + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].unitCur !== '') {
          tableContent += details3[i].unitCur + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].totAmt !== '') {
          tableContent += details3[i].totAmt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].currency_code !== '') {
          tableContent += details3[i].currency_code + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].ritc !== '') {
          tableContent += details3[i].ritc + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].cth !== '') {
          tableContent += details3[i].cth + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].ceth !== '') {
          tableContent += details3[i].ceth + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].bcdNt !== '') {
          tableContent += details3[i].bcdNt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].bcdSr !== '') {
          tableContent += details3[i].bcdSr + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].bcdRt !== '') {
          tableContent += details3[i].bcdRt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].bcdAmt !== '') {
          tableContent += details3[i].bcdAmt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].bcdUnit !== '') {
          tableContent += details3[i].bcdUnit + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].cvdNt !== '') {
          tableContent += details3[i].cvdNt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].cvdSr !== '') {
          tableContent += details3[i].cvdSr + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].cvdRt !== '') {
          tableContent += details3[i].cvdRt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].cvdAmt !== '') {
          tableContent += details3[i].cvdAmt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].cvdUnit !== '') {
          tableContent += details3[i].cvdUnit + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].aCvdNt !== '') {
          tableContent += details3[i].aCvdNt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].aCvdSr !== '') {
          tableContent += details3[i].aCvdSrv + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].aCvdRt !== '') {
          tableContent += details3[i].aCvdRt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].aCvdAmt !== '') {
          tableContent += details3[i].aCvdAmt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].aCvdUnit !== '') {
          tableContent += details3[i].aCvdUnit + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].scdNt !== '') {
          tableContent += details3[i].scdNt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].scdSr !== '') {
          tableContent += details3[i].scdSr + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].scdRt !== '') {
          tableContent += details3[i].scdRt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].scdAmt !== '') {
          tableContent += details3[i].scdAmt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].scdUnit !== '') {
          tableContent += details3[i].scdUnit + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].sCessNt !== '') {
          tableContent += details3[i].sCessNt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].sCessSr !== '') {
          tableContent += details3[i].sCessSr + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].sCessRt !== '') {
          tableContent += details3[i].sCessRt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].sCessAmt !== '') {
          tableContent += details3[i].sCessAmt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].sCessUnit !== '') {
          tableContent += details3[i].sCessUnit + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].saptNot !== '') {
          tableContent += details3[i].saptNot + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].saptNotSr !== '') {
          tableContent += details3[i].saptNotSr + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].saptRt !== '') {
          tableContent += details3[i].saptRt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].paraNo !== '') {
          tableContent += details3[i].paraNo + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].policyYear !== '') {
          tableContent += details3[i].policyYear + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].genDesc !== '') {
          tableContent += details3[i].genDesc + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].manName !== '') {
          tableContent += details3[i].manName + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].brand !== '') {
          tableContent += details3[i].brand + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].modelNo !== '') {
          tableContent += details3[i].modelNo + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].itemAccessories !== '') {
          tableContent += details3[i].itemAccessories + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].addAmt1 !== '') {
          tableContent += details3[i].addAmt1 + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].addRt1 !== '') {
          tableContent += details3[i].addRt1 + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].addUnit1 !== '') {
          tableContent += details3[i].addUnit1 + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].addNot1 !== '') {
          tableContent += details3[i].addNot1 + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].addNotSr1 !== '') {
          tableContent += details3[i].addNotSr1 + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].addAmt2 !== '') {
          tableContent += details3[i].addAmt2 + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].addRt2 !== '') {
          tableContent += details3[i].addRt2 + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].addUnit2 !== '') {
          tableContent += details3[i].addUnit2 + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].addNot2 !== '') {
          tableContent += details3[i].addNot2 + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].addNotSr2 !== '') {
          tableContent += details3[i].addNotSr2 + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].otAmt !== '') {
          tableContent += details3[i].otAmt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].otRt !== '') {
          tableContent += details3[i].otRt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].otNot !== '') {
          tableContent += details3[i].otNot + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].otNotSr !== '') {
          tableContent += details3[i].otNotSr + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].otUnit !== '') {
          tableContent += details3[i].otUnit + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].cessAmt !== '') {
          tableContent += details3[i].cessAmt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].cessRt !== '') {
          tableContent += details3[i].cessRt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].totDuty !== '') {
          tableContent += details3[i].totDuty + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].cessUnit !== '') {
          tableContent += details3[i].cessUnit + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].cessNot !== '') {
          tableContent += details3[i].cessNot + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].cessNotSr !== '') {
          tableContent += details3[i].cessNotSr + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].aggNot !== '') {
          tableContent += details3[i].aggNot + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].aggNotSr !== '') {
          tableContent += details3[i].aggNotSr + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].aggAmt !== '') {
          tableContent += details3[i].aggAmt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].aggUnit !== '') {
          tableContent += details3[i].aggUnit + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].ncdNot !== '') {
          tableContent += details3[i].ncdNot + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].ncdNotSr !== '') {
          tableContent += details3[i].ncdNotSr + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].ncdAmt !== '') {
          tableContent += details3[i].ncdAmt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].ncdUnit !== '') {
          tableContent += details3[i].ncdUnit + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].ncdSec !== '') {
          tableContent += details3[i].ncdSec + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].ncdRt !== '') {
          tableContent += details3[i].ncdRt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].auntiNot !== '') {
          tableContent += details3[i].auntiNot + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].auntiNotSr !== '') {
          tableContent += details3[i].auntiNotSr + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].auntiRt !== '') {
          tableContent += details3[i].auntiRt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].auntiClass !== '') {
          tableContent += details3[i].auntiClass + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].auntiAmt !== '') {
          tableContent += details3[i].auntiAmt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].auntiUnit !== '') {
          tableContent += details3[i].auntiUnit + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].cthSrNo !== '') {
          tableContent += details3[i].cthSrNo + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].supSrNo !== '') {
          tableContent += details3[i].supSrNo + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].auntiCur !== '') {
          tableContent += details3[i].auntiCur + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].tariffNot !== '') {
          tableContent += details3[i].tariffNot + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].tariffNotSr !== '') {
          tableContent += details3[i].tariffNotSr + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].tariffUnit !== '') {
          tableContent += details3[i].tariffUnit + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].tariffCur !== '') {
          tableContent += details3[i].tariffCur + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].rspAmt !== '') {
          tableContent += details3[i].rspAmt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].rspUnit !== '') {
          tableContent += details3[i].rspUnit + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].swsNot !== '') {
          tableContent += details3[i].swsNot + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].swsNotSr !== '') {
          tableContent += details3[i].swsNotSr + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].swsAmt !== '') {
          tableContent += details3[i].swsAmt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].swsRt !== '') {
          tableContent += details3[i].swsRt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].swsUnit !== '') {
          tableContent += details3[i].swsUnit + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].itemAssVal !== '') {
          tableContent += details3[i].itemAssVal + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].igstNotSr !== '') {
          tableContent += details3[i].igstNotSr + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].igstRt !== '') {
          tableContent += details3[i].igstRt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].igstAmount !== '') {
          tableContent += details3[i].igstAmount + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].igstUnit !== '') {
          tableContent += details3[i].igstUnit + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].igstNot !== '') {
          tableContent += details3[i].igstNot + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].igstCessNot !== '') {
          tableContent += details3[i].igstCessNot + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].igstCessNotSr !== '') {
          tableContent += details3[i].igstCessNotSr + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].igstCessRt !== '') {
          tableContent += details3[i].igstCessRt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].igstCessAmt !== '') {
          tableContent += details3[i].igstCessAmt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].igstCessUnit !== '') {
          tableContent += details3[i].igstCessUnit + "#"
        } else {
          tableContent += '  #';
        }
        contenall += tableContent;
      }
      // console.log('contenall => '+JSON.stringify(contenall))
      let details = {
        headerName: "3,0,DSR REPORT 3", headerDetails: "1,1,FROM DATE : " + dsr3Values.from + "/4,1,TO DATE : " + dsr3Values.to,
        tableHeader: "0,3,Sl.No/1,3,Branch Name/2,3,Operation Type/3,3,JOB_NO/4,3,JOB_DATE/5,3,CHA NUMBER/6,3,IMPORTER CODE/7,3,IMPORTER BRANCH/8,3,IMPORTER NAME/9,3,IMPORTER ADDRESS 1/10,3,IMPORTER ADDRESS 2/11,3,IMPORTER CITY/12,3,IMPORTER STATE/13,3,IMPORTER PINCODE/14,3,PORT_CD/15,3,COUNTRY OF ORIGIN/16,3,PORT OF ORIGIN/17,3,COUNTRY IF COSIGNMENT/18,3,CERTIFICATE STATE CODE/19,3,CERTIFICATE TYPE/20,3,CERTIFICATE REGISTRATION NO/21,3,TOTAL FRIEGHT RATE/22,3,TOTAL INSSURANCE RATE/23,3,TOTAL MISCELLANEOUS CHARGES/24,3,TOTAL ASSESABLE VALUE/25,3,TOTAL DUTY/26,3,GROSS WEIGHT/27,3,TOTAL INSSURANCE/28,3,MODE OF TRANSPORT/29,3,IGM SERIAL NO/30,3,ROTATION NO/31,3,ROTATION DATE/32,3,MAWB NO/33,3,MAWB DATE/34,3,HAWB NO/35,3,HAWB DATE/36,3,INWARD DATE/37,3,TOTAL PACKAGES/38,3,GROSS WEIGHT1/39,3,UNIT QUANTITY INVOKED/40,3,GATEWAY IGM NO/41,3,GATEWAY INWARD DATE/42,3,REPORTING PORT/43,3,TOTAL DUTY1/44,3,INVOICE SR NO/45,3,INVOICE NUMBER/46,3,INVOICE DATE/47,3,INVOICE VALUE/48,3,INVOICE CURRENCY/49,3,INVOICE EXCHANGE RATE/50,3,INVOICE TERM/51,3,NATURE OF TRANSACTION/52,3,PAYMENT TERMS/53,3,SUPPLIER NAME/54,3,SUPPLIER ADDRESS 1/55,3,SUPPLIER ADDRESS 2/56,3,SUPPLIER ADDRESS 3/57,3,SUPPLIER COINTRY/58,3,FRIEGHT VALUE/59,3,FRIEGHT CURRENCY/60,3,FRIEGHT RATE/61,3,INSSURANCE VALUE/62,3,INSSURANCE CURRENCY/63,3,INSSURANCE RATE/64,3,TOTAL INSSURANCE1/65,3,LOAD CURRENCY/66,3,LOAD RATE/67,3,MISCELLANEOUS CHARGES/68,3,MISCELLANEOUS CURRENCY/69,3,MISCELLANEOUS RATE/70,3,HSS LOAD AMOUNT/71,3,HSS LOAD RATE/72,3,DISCOUNT RATE/73,3,DISCOUNT AMOUNT/74,3,SVB LOAD ON DUTY/75,3,SELLER NAME/76,3,SELLER ADDRESS 1/77,3,SELLER ADDRESS 2/78,3,SELLER ADDRESS 3/79,3,SELLER COUNTRY/80,3,SELLER PINCODE/81,3,DISCOUNT RATE1/82,3,DISCOUNT AMOUNT1/83,3,SVB LOAD ON DUTY1/84,3,ITEM NO/85,3,ITEM DESCRIPTION 1/86,3,ITEM DESCRIPTION 2/87,3,NUMBER OF UNIT/88,3,ITEM UNIT QUANTITY/89,3,ITEM UNIT PRICE/90,3,UNIT PRICE CURRENCY CODE/91,3,TOTAL AMOUNT/92,3,TOTAL AMOUNT CURRENCY/93,3,RITC CODE/94,3,CTH NO/95,3,CETH NO/96,3,BCD NOTIFICATION NO/97,3,BCD NOTIFICATION SR NO/98,3,BCD RATE/99,3,BCD AMOUNT/100,3,BCD UNIT/101,3,CVD NOTIFICATION NO/102,3,CVD  NOTIFICATION SR NO/103,3,CVD RATE/104,3,CVD AMOUNT/105,3,CVD UNIT/106,3,ADVANCE CVD NOTIFICATION NO/107,3,ADVANCE CVD NOTIFICATION SR NO/108,3,ADVANCE CVD RATE/109,3,ADVANCE CVD AMOUNT/110,3,ADVANCE CVD UNIT/111,3,SCD NOTIFICATION NO/112,3,SCD NOTIFICATION SR NO/113,3,SCD RATE/114,3,SCD AMOUNT/115,3,SCD UNIT/116,3,SCHEDULE CESS NOTIFICATION NO/117,3,SCHEDULE CESS NOTIFICATION SR NO/118,3,SCHEDULE CESS RATE/119,3,SCHEDULE CESS AMOUNT/120,3,SCHEDULE CESS UNIT/121,3,SAPTA NOTIFICATION NO/122,3,SAPTA NOTFICATION SR NO/123,3,SAPTA RATE/124,3,PARA NO/125,3,POLICY YEAR/126,3,GENERAL DESCRIPTION/127,3,MANUFACTURE NAME/128,3,BRAND NAME/129,3,MODEL NO/130,3,ITEM ACCESSORIES DESCRIPTION/131,3,AD1 AMOUNT/132,3,AD1 RATE/133,3,AD1 UNIT/134,3,AD1 NOTIFICATION NO/135,3,AD1 NOTIFICATION SR NO/136,3,AD2 AMOUNT/137,3,AD2 RATE/138,3,AD2 UNIT/139,3,AD2 NOTIFICATION NO/140,3,AD2 NOTIFICATION SR NO/141,3,OTHER AMOUNT/142,3,OTHER RATE/143,3,OTHER NOTIFICATION NO/144,3,OTHER NOTIFICATION SR NO/145,3,OTHER UNIT/146,3,CESS AMOUNT/147,3,CESS RATE/148,3,CESS UNIT/149,3,CESS NOTIFCATION NO/150,3,CESS NOTIFICATION SR NO/151,3,AGGREGATE NOTIFICATION/152,3,AGGREGATE NOTIFICATION SR NO/153,3,AGGREGATE AMOUNT/154,3,AGGREGATE UNIT/155,3,AGGREGATE RATE/156,3,NCD NOTIFICATION NO/157,3,NCD NOTIFICATION SR NO/158,3,NCD AMOUNT/159,3,NCD UNIT/160,3,NCD SECTION/161,3,NCD RATE/162,3,ANTIDUMPING NOTIFICATION NO/163,3,ANTIDUMPING NOTIFICATION SR NO/164,3,ANTIDUMPING RATE/165,3,ANTIDUMPING CLASS/166,3,ANTIDUMPING AMOUNT/167,3,ANTIDUMPING UNIT/168,3,CTH SR NO/169,3,SUPPLIER SR NO/170,3,ANTIDUMPING CURRENCY/171,3,TARIFF NOTIFICATION NO/172,3,TARIFF NOTIFICATION SR NO/173,3,TARIFF UNIT/174,3,TARIFF CURRENCY/175,3,RSP AMOUNT/176,3,RSP NO OF UNIT/177,3,SWS NOTIFICATION NO/178,3,SWS NOTIFICATION SR NO/179,3,SWS AMOUNT/180,3,SWS RATE/181,3,SWS UNIT QUANTITY/182,3,ITEM ASSESS VAL/183,3,IGST NOTIFICATION SR NO/184,3,IGST RATE/185,3,IGST AMOUNT/186,3,IGST UNIT/187,3,IGST NOTIFICATION NO/188,3,IGST CESS NOTIFICATION NO/189,3,IGST CESS NOTIFICATION SR NO/190,3,IGST CESS RATE/191,3,IGST CESS AMOUNT/192,3,IGST CESS UNIT",
        tableRowStartsFrom: 4, tableColumnStartsFrom: 0, fileCode: "dsr3", totalNumberOfColumn: 193, tableContent: contenall.substring(0, contenall.length - 1),
      }
      DSR_Services.Excelwrite(details).then((res) => {
        const filename = res.data.message;
        // window.open('http://localhost:8080/ExportFiles/' + filename.toString(), "_blank")
        window.open('http://35.154.221.117:8081/ExportFiles/' + filename.toString(), "_blank");

      })
    }
    setreportProcs(false)
  }
  const clrBtnClick = () => {
    setclearProcs(true)
    setshowProcs(false)
    setdsr3Values({ ...dsr3Values, from: getDate(), to: getDate(), branch: '-1', customer: '-1', operation: '-1', })
    setdetails3([])
    setFilteredDetails([])
    setreportProcs(false)
    setclearProcs(false)
  }
  useEffect(() => {
    setloading(true)
    setTimeout(() => {
      setloading(false)
    }, 1000)
    getfunctions();
  }, []);


  //tableSearch
  const branchNmSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { branchNmOnchange(e.target.value) }} />
  }
  const opertionTypeSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { opertionTypeOnchange(e.target.value) }} />
  }
  const jobNoSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { jobNoOnchange(e.target.value) }} />
  }
  const impNmSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { impNmOnchange(e.target.value) }} />
  }
  const impcitySrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { impcityOnchange(e.target.value) }} />
  }
  const PortCdSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { PortCdOnchange(e.target.value) }} />
  }
  const cntryOrginSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { cntryOrginOnchange(e.target.value) }} />
  }
  const portOriginSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { portOriginOnchange(e.target.value) }} />
  }
  const modeofTrnsportSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { modeofTrnsportOnchange(e.target.value) }} />
  }
  const reportingPortSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { reportingPortOnchange(e.target.value) }} />
  }
  const invoiceNoSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { invoiceNoOnchange(e.target.value) }} />
  }
  const SupplierNmSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { SupplierNmOnchange(e.target.value) }} />
  }
  const SuppliercntrySrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { SuppliercntryOnchange(e.target.value) }} />
  }
  const itemDesc1Srch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { itemDesc1Onchange(e.target.value) }} />
  }
  //
  const branchNmOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.regionalName.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const opertionTypeOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.operationType.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const jobNoOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.consignmentNumber.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const impNmOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.importer_name.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const impcityOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.importerCity.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const PortCdOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.cusHouseCode.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const cntryOrginOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.countryOfOrigin.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const portOriginOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.origin_portName.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const modeofTrnsportOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.transitTypeCode.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const reportingPortOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.gateWay_port_code.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const invoiceNoOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.invoiceNumber.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const SupplierNmOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.supName.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const SuppliercntryOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.supCountry.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const itemDesc1Onchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.item_description.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  //paginationCodes

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }
  return (
    <div>
      <Home />
      <div style={{ paddingLeft: '100px' }}>
        <Snackbar open={open} message={message} severity={severit} onClose={handleClose} />
        {loading ?
          <div className="loaderCss">
            <HashLoader
              color={"#296cbc"}
              loading={loading}
              size={50}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </div>
          :
          <ItemPap>
            <Row>
              <div className='Billingtitleclr' style={{ color: 'red', fontWeight: 'bold', fontSize: '25px', marginTop: '1%', marginBottom: '1%', }}><center>DSR-3 REPORT</center></div>
              <Col></Col>
              <Col><center>
                <label style={mystyle1}>From Date</label>
                <Form.Control size="sm" type="date" style={mystyle} value={dsr3Values.from} onChange={fromhandlechange} /></center>
              </Col>
              <Col><center>
                <label style={mystyle1}>To Date</label>
                <Form.Control size="sm" type="date" style={mystyle} value={dsr3Values.to} onChange={tohandlechange} /></center>
              </Col>
              <Col><center>
                <label style={mystyle1}>Branch</label>
                <Form.Select size="sm" style={mystyle} value={dsr3Values.branch} onChange={branchhandlechange}>
                  {details1.map(trns => (
                    <option value={trns.regionId}>{trns.regionalName}</option>
                  ))}
                </Form.Select></center>
              </Col>
              <Col><center>
                <label style={mystyle1}>Customer</label>
                <Form.Select type="text" list="code" style={mystyle} size="sm" value={dsr3Values.customer} onChange={customerhandlechange}>
                  <option value={'-1'}>ALL</option>
                  {details2.map(trns => (
                    <option value={trns.importer_iec_no}>{trns.importer_name}</option>
                  ))}
                </Form.Select></center>
              </Col>
              <Col><center>
                <label style={mystyle1}>Operation</label>
                <Form.Select size="sm" style={mystyle} value={dsr3Values.operation} onChange={operationhandlechange}>
                  <option value={'-1'}>ALL</option>
                  <option value={'IMPORT'}>IMPORT</option>
                  <option value={'EXPORT'}>EXPORT</option>
                  <option value={'COURIER'}>COURIER</option>
                </Form.Select></center>
              </Col>
              <Col></Col>
            </Row>
            <Row className="mb-1 mt-2">
              <Col lg={4}></Col>
              <Col lg={4}>
                <Button variant="primary" style={{ fontFamily: 'Times New Roman'}}size="sm" onClick={showBtnClick}> {showProcs ? 'processing...' : 'Show'} </Button>
                &nbsp;
                <Button variant="success" style={{ fontFamily: 'Times New Roman'}}size="sm" onClick={reportBtnClick}>{reportProcs ? 'processing...' : 'Report'}</Button>
                &nbsp;
                <Button variant="danger"style={{ fontFamily: 'Times New Roman'}} size="sm" onClick={clrBtnClick}> {clearProcs ? 'processing...' : 'Reset'} </Button>
              </Col>
              <Col lg={4}></Col>
            </Row>
            <ItemPap1>
              <TableContainer sx={{ height: 410 }} className="mt-1">
                <Table stickyHeader className="table table-bordered">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell>SlNo</StyledTableCell>
                      <StyledTableCell>BranchName{branchNmSrch()}</StyledTableCell>
                      <StyledTableCell>OperationType{opertionTypeSrch()}</StyledTableCell>
                      <StyledTableCell>JobNo{jobNoSrch()}</StyledTableCell>
                      <StyledTableCell>JobDate</StyledTableCell>
                      <StyledTableCell>CHA_NO</StyledTableCell>
                      <StyledTableCell>ImporterCode</StyledTableCell>
                      <StyledTableCell>ImporterBranch</StyledTableCell>
                      <StyledTableCell>ImporterName{impNmSrch()}</StyledTableCell>
                      <StyledTableCell>ImporterAddress1</StyledTableCell>
                      <StyledTableCell>ImporterAddress2</StyledTableCell>
                      <StyledTableCell>ImporterCity{impcitySrch()}</StyledTableCell>
                      <StyledTableCell>ImporterState</StyledTableCell>
                      <StyledTableCell>ImporterPincode</StyledTableCell>
                      <StyledTableCell>PortCode{PortCdSrch()}</StyledTableCell>
                      <StyledTableCell>CountryOfOrigin{cntryOrginSrch()}</StyledTableCell>
                      <StyledTableCell>PortOfOrigin{portOriginSrch()}</StyledTableCell>
                      <StyledTableCell>CountryOfCM</StyledTableCell>
                      <StyledTableCell>CertificateStateCode</StyledTableCell>
                      <StyledTableCell>CertificateType</StyledTableCell>
                      <StyledTableCell>CertificateNo</StyledTableCell>
                      <StyledTableCell>TotalFreightRate</StyledTableCell>
                      <StyledTableCell>TotalInsuranceRate</StyledTableCell>
                      <StyledTableCell>TotalMischarge</StyledTableCell>
                      <StyledTableCell>TotalAssessibleValue</StyledTableCell>
                      <StyledTableCell>TotalDuty</StyledTableCell>
                      <StyledTableCell>GrossWeight</StyledTableCell>
                      <StyledTableCell>TotalInsurance</StyledTableCell>
                      <StyledTableCell>ModeOfTransport{modeofTrnsportSrch()}</StyledTableCell>
                      <StyledTableCell>IGM_SerialNo</StyledTableCell>
                      <StyledTableCell>RotationNo</StyledTableCell>
                      <StyledTableCell>RotationDate</StyledTableCell>
                      <StyledTableCell>MAWB/MBL_No</StyledTableCell>
                      <StyledTableCell>MAWB/MBL_Date</StyledTableCell>
                      <StyledTableCell>HAWB/HBL_No</StyledTableCell>
                      <StyledTableCell>HAWB/HBL_Date</StyledTableCell>
                      <StyledTableCell>InwardDate</StyledTableCell>
                      <StyledTableCell>NoofPkg</StyledTableCell>
                      <StyledTableCell>Gross_WT</StyledTableCell>
                      <StyledTableCell>Unit</StyledTableCell>
                      <StyledTableCell>GatewayIGM_No</StyledTableCell>
                      <StyledTableCell>GatewayIGM_Date</StyledTableCell>
                      <StyledTableCell>ReportingPort{reportingPortSrch()}</StyledTableCell>
                      <StyledTableCell>TotalDuty1</StyledTableCell>
                      <StyledTableCell>InvoiceSrNo</StyledTableCell>
                      <StyledTableCell>InvoiceNo{invoiceNoSrch()}</StyledTableCell>
                      <StyledTableCell>InvoiceDate</StyledTableCell>
                      <StyledTableCell>InvoiceValue</StyledTableCell>
                      <StyledTableCell>InvoiceCurrency</StyledTableCell>
                      <StyledTableCell>InvoiceExRate</StyledTableCell>
                      <StyledTableCell>InvoiceTerms</StyledTableCell>
                      <StyledTableCell>NatureTransaction</StyledTableCell>
                      <StyledTableCell>PaymentTerms</StyledTableCell>
                      <StyledTableCell>SupplierName{SupplierNmSrch()}</StyledTableCell>
                      <StyledTableCell>SupplierAddress1</StyledTableCell>
                      <StyledTableCell>SupplierAddress2</StyledTableCell>
                      <StyledTableCell>SupplierAddress3</StyledTableCell>
                      <StyledTableCell>SupplierCountry{SuppliercntrySrch()}</StyledTableCell>
                      <StyledTableCell>FreightValue</StyledTableCell>
                      <StyledTableCell>FreightCurrency</StyledTableCell>
                      <StyledTableCell>FreightRate</StyledTableCell>
                      <StyledTableCell>InsuranceValue</StyledTableCell>
                      <StyledTableCell>InsuranceCurrency</StyledTableCell>
                      <StyledTableCell>InsuranceRate</StyledTableCell>
                      <StyledTableCell>TotalInsurance</StyledTableCell>
                      <StyledTableCell>LoadCurrency</StyledTableCell>
                      <StyledTableCell>LoadRate</StyledTableCell>
                      <StyledTableCell>MiscCharge</StyledTableCell>
                      <StyledTableCell>MiscCurrency</StyledTableCell>
                      <StyledTableCell>MiscRate</StyledTableCell>
                      <StyledTableCell>HSSLoadAmount</StyledTableCell>
                      <StyledTableCell>HSSLoadRate</StyledTableCell>
                      <StyledTableCell>DiscountRate</StyledTableCell>
                      <StyledTableCell>DiscountAmount</StyledTableCell>
                      <StyledTableCell>SVBLoadOnDuty</StyledTableCell>
                      <StyledTableCell>SellerName</StyledTableCell>
                      <StyledTableCell>SellerAddress1</StyledTableCell>
                      <StyledTableCell>SellerAddress2</StyledTableCell>
                      <StyledTableCell>SellerAddress3</StyledTableCell>
                      <StyledTableCell>SellerCountry</StyledTableCell>
                      <StyledTableCell>SellerPincode</StyledTableCell>
                      <StyledTableCell>DiscountRate1</StyledTableCell>
                      <StyledTableCell>DiscountAmount1</StyledTableCell>
                      <StyledTableCell>SVBLoadOnDuty1</StyledTableCell>
                      <StyledTableCell>ItemNo</StyledTableCell>
                      <StyledTableCell>ItemDescription1{itemDesc1Srch()}</StyledTableCell>
                      <StyledTableCell>ItemDescription2</StyledTableCell>
                      <StyledTableCell>Item_NoOfUnit</StyledTableCell>
                      <StyledTableCell>Item_UmitQty</StyledTableCell>
                      <StyledTableCell>Item_UnitPrice</StyledTableCell>
                      <StyledTableCell>Item_UnitCurrency</StyledTableCell>
                      <StyledTableCell>TotalAmount</StyledTableCell>
                      <StyledTableCell>TotalCurrency</StyledTableCell>
                      <StyledTableCell>RITC_Code</StyledTableCell>
                      <StyledTableCell>CTH_No</StyledTableCell>
                      <StyledTableCell>CETH_No</StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {FilteredDetails.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((trns, index) => (
                        <TableRow hover key={trns.serialNumber}>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.serialNumber}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.regionalName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.operationType}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.consignmentNumber}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.transitDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.licenceNo}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.importer_iec_no}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.branchSlNo}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.importer_name}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.importerAddress}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.importerAddress2}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.importerCity}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.importerState}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.importerPincode}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.cusHouseCode}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.countryOfOrigin}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.origin_portName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.countryOfCmName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.certificateTypeDesc}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.certificateType}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.certificateNo}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.totFrtRt}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.totInsRt}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.totMiscRt}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.totAssesableVal}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.totDuty}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.grossWt}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.totIns}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.transitTypeCode}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.igmSrNo}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.rotNo}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.rotDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.MAWBNo}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.mawb_date}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.hawb_no}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.hawbDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.inwardDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.noPkg}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.grossWt}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.unit}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.gateWay_igmNo}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.gateWay_igmDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.gateWay_port_code}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.totDuty1}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.invoiceSrNo}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.invoiceNumber}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.invoiceDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.invoiceVal}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.invoiceCur}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.exRate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.terms_code}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.nattransaction}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.payTerms}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.supName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.supplierAddress}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.supAddress2}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.supAddress3}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.supCountry}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.frtVal}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.frtCur}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.frtRt}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.insVal}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.insCur1}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.insRt}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.totIns1}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.loadCur}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.loadRt}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.miscVal}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.miscCur}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.miscRt}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.hssLoadAmt}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.hssLoadRt}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.discRate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.disAmt}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.svbLoad}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.sellName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.sellAddress1}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.sellAddress2}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.sellAddress3}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.sellCountry}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.sellPincode}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.disrt1}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.disAmt1}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.svbLoad1}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.itemSrNo}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.item_description}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.itemDesc}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.unitQty}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.unitCode}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.unitPri}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.unitCur}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.totAmt}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.currency_code}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.ritc}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.cth}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.ceth}</StyledTableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                showFirstButton
                showLastButton
                component='div'
                count={FilteredDetails.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onChangeRowsPerpage={handleChangeRowsPerPage}
              />
            </ItemPap1>
          </ItemPap>}
      </div>
    </div>
  );
}

export default DSR3;
